export function StarsIcon({
  width = 52,
  height = 36,
  className = '',
  color = '#fff',
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      {...props}
    >
      <path
        fill={props.fill}
        fillRule="evenodd"
        d="M25.676 4.552a.77.77 0 0 1-.53.718 3.71 3.71 0 0 0-2.31 2.327.736.736 0 0 1-.72.531.75.75 0 0 1-.718-.53 3.7 3.7 0 0 0-2.327-2.31.77.77 0 0 1-.53-.72.735.735 0 0 1 .53-.718 3.76 3.76 0 0 0 2.31-2.327.77.77 0 0 1 .719-.53.736.736 0 0 1 .718.53 3.78 3.78 0 0 0 2.328 2.327.74.74 0 0 1 .53.702m-2.666.909a4.7 4.7 0 0 1 1.25-.901 4.8 4.8 0 0 1-2.16-2.167 4.76 4.76 0 0 1-2.157 2.172 4.7 4.7 0 0 1 2.172 2.157c.227-.466.529-.892.895-1.261M8.39 2.463h-.978v-.979a.5.5 0 1 0-1 0v.98h-.979a.5.5 0 0 0 0 1h.979v.978a.5.5 0 0 0 1 0v-.979h.979a.5.5 0 1 0 0-1m8.988 12.05a.5.5 0 1 0 0 1h.979v.98a.5.5 0 1 0 1 0v-.98h.979a.5.5 0 0 0 0-1h-.979v-.979a.5.5 0 0 0-1 0v.98zm-3.886-.925a8 8 0 0 0-.282.693l-.01.026-.007.027a.367.367 0 0 1-.583.185.4.4 0 0 1-.14-.2l-.004-.014-.005-.013a7.87 7.87 0 0 0-4.917-4.917l-.017-.006-.017-.005a.43.43 0 0 1-.305-.376V8.98a.43.43 0 0 1 .297-.412h.003a7.87 7.87 0 0 0 4.671-4.18l-.001-.001q.157-.339.282-.693l.01-.026.007-.027a.367.367 0 0 1 .583-.185c.066.05.115.121.14.2l.004.014.005.014a7.87 7.87 0 0 0 4.917 4.917l.017.005.017.006a.43.43 0 0 1 .305.375v.007a.43.43 0 0 1-.297.412l-.003.001a7.87 7.87 0 0 0-4.671 4.18zM7.327 7.572l-.136.047a1.43 1.43 0 0 0-.986 1.367v.032a1.43 1.43 0 0 0 1.017 1.303 6.87 6.87 0 0 1 4.292 4.293 1.4 1.4 0 0 0 1.304.985 1.37 1.37 0 0 0 1.335-.985 6.9 6.9 0 0 1 4.193-4.205l-.006-.005q.068-.024.137-.047a1.43 1.43 0 0 0 .985-1.367v-.032a1.43 1.43 0 0 0-1.017-1.303 6.87 6.87 0 0 1-4.292-4.292 1.4 1.4 0 0 0-1.304-.986 1.37 1.37 0 0 0-1.335.986 6.9 6.9 0 0 1-4.192 4.204zm-.191 5.867a.77.77 0 0 1-.53.719 3.71 3.71 0 0 0-2.31 2.327.735.735 0 0 1-.72.53.75.75 0 0 1-.718-.53 3.7 3.7 0 0 0-2.327-2.31.77.77 0 0 1-.53-.719.736.736 0 0 1 .53-.719 3.76 3.76 0 0 0 2.31-2.327.77.77 0 0 1 .718-.53.736.736 0 0 1 .72.53 3.78 3.78 0 0 0 2.326 2.327.74.74 0 0 1 .53.702m-2.666.909a4.7 4.7 0 0 1 1.249-.901A4.8 4.8 0 0 1 3.56 11.28a4.76 4.76 0 0 1-2.157 2.172 4.7 4.7 0 0 1 2.172 2.157c.226-.465.528-.892.895-1.261"
        clipRule="evenodd"
        className={className}
        color={color}
      />
    </svg>
  );
}
